import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-6 gap-3">
      <p className="text-muted-foreground text-sm">404 · Not found</p>
      <Link to="/" className="text-primary underline text-sm">
        Back to home
      </Link>
    </main>
  );
}